<template>
    <div>
    </div>
</template>
<script>
    import axios from 'axios'
    import {mapState} from 'vuex'

    export default {
        name: 'menus',
        mounted: function () {

        },
        computed: mapState({
            tokenAPI: function (state) {
                return state.tokenAPI;
            },
            token: function (state) {
                return state.token;
            },
            getuserAPI: function (state) {
                return state.getuserAPI;
            }
        }),
        methods: {
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            getuser(token) {
                var vm = this;
                axios.get(vm.getuserAPI, {
                    withCredentials: true,
                    headers: {'x-requested-with': 'XMLHttpRequest', 'access-token': token},
                }).then((response) => {
                    if (response.data.code !== 0) {
                        return;
                    }
                    vm.user = response.data.data;
                    if (vm.user != null) {
                        document.cookie = "username=" + vm.user.login;
                    }
                }).catch(function (error) {
                    vm.requesterrorinfo(error);
                })
            },
            requesterrorinfo(error) {
                var vm = this;

                if (error.response) {
                    var code = error.response.status;
                    if (code == 401) {
                        vm.$message('您未登录,请刷新');
                        var count = vm.getCookie("access-count")
                        if (count == null || count == 0) {
                            document.cookie = "access-count=1";
                            document.cookie = vm.cookieName + vm.$route.fullPath;
                            window.location = vm.loginRediret;
                        } else {
                            vm.$message("未登录请刷新页面");
                        }

                    } else {
                        if (code == 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'
                    });
                }
            }
        },
        data() {
            return {
                user: ""
            }
        }
    }
</script>



// WEBPACK FOOTER //
// callback.vue?3d51c66b